export default {
	USDT: 'USDT',
	保存并下次使用: '保存并下次使用',
	保存此卡以用于后续支付: '保存此卡以用于后续支付',
	操作: '操作',
	操作失败: '操作失败',
	操作时间: '操作时间',
	查看发票: '查看发票',
	查看记录: '查看记录',
	查看信用发票: '查看信用发票',
	查看信用记录: '查看信用记录',
	持卡人姓名: '持卡人姓名',
	充值记录: '充值记录',
	充值金额: '充值金额',
	充值提示: '请输入 {min}～{max} 范围的整数',
	创建时间: '创建时间',
	打印: '打印',
	打印时间: '打印时间',
	到期: '到期',
	到期日期: '到期日期',
	订单编号: '订单编号',
	订单发票: '订单发票',
	订单详情: '订单详情',
	订单支付: '订单支付',
	发票编号: '发票编号',
	发票项目: '发票项目',
	发票PDF: '发票PDF',
	非常感谢您的付款已成功完成: '非常感谢，您的付款已成功完成',
	复制链接: '复制链接',
	复制失败: '复制失败',
	管理信用卡: '管理信用卡',
	交易详情: '交易详情',
	接收方: '接收方',
	金额: '金额',
	金额已复制: '金额已复制',
	进行实名认证: '进行实名认证',
	卡片保存成功: '卡片保存成功',
	可用余额: '可用余额',
	类型: '类型',
	立即充值: '立即充值',
	链接已复制: '链接已复制',
	登录提醒: '登录提醒',
	描述: '描述',
	默认: '默认',
	内容: '内容',
	其它支付方式: '其他支付方式（支持信用卡、支付宝、微信等）',
	请扫描二维码或点击金额和地址粘贴转账USDT支付: '请扫描二维码或点击金额和地址粘贴转账，USDT(trc-20) 支付。',
	'请使用微信「扫一扫」': '请使用微信「扫一扫」',
	'请使用支付宝「扫一扫」': '请使用支付宝「扫一扫」',
	请输入持卡人姓名: '请输入持卡人姓名',
	请输入发票编号: '请输入发票编号',
	请先获取支付信息: '请先获取支付信息',
	请先登录后使用该支付方式: '请先登录后使用该支付方式',
	请先进行实名认证或提升实名认证等级: '请先进行实名认证或提升实名认证等级',
	确认删除此卡吗: '确认删除此卡吗？',
	去登录: '去登录',
	删除此卡: '删除此卡',
	商品名称: '商品名称',
	设为自动扣款: '设为自动扣款',
	生成日期: '生成日期',
	生成时间: '生成时间',
	实名认证提醒: '实名认证提醒',
	使用浏览器打开支付页面: '使用浏览器打开支付页面',
	使用新卡: '使用新卡',
	使用信用卡: '使用信用卡',
	使用已保存的卡: '使用已保存的卡',
	使用已保存的卡片: '使用已保存的卡片',
	输入新卡支付: '输入新卡支付',
	拖动卡片进行排序: '拖动卡片进行排序',
	微信扫码支付: '请使用微信扫码完成支付',
	微信支付: '微信支付',
	下载: '下载',
	小计: '小计',
	新增信用卡: '新增信用卡',
	信用发票: '信用发票',
	信用记录: '信用记录',
	信用卡: '信用卡',
	信用余额: '信用余额',
	信用余额可用于后续平台的消费: '信用余额可用于后续平台的消费',
	选择支付方式: '选择支付方式',
	已过期: '支付已过期',
	应付金额: '应付金额',
	余额: '余额',
	余额不足: '余额不足，请充值或选择其它支付方式',
	账号概况: '账号概况',
	正在验证: '正在验证...',
	支付: '支付',
	支付宝: '支付宝',
	支付成功: '支付成功',
	支付初始化失败: '支付初始化失败',
	支付方式: '支付方式',
	支付金额: '支付金额',
	支付日期: '支付日期',
	支付失败: '支付失败',
	支付时间: '支付时间',
	支付信息: '支付信息',
	支付中: '支付中...',
	支付ID: '支付ID',
	转账金额必须为下方显示带小数点的金额: '转账金额必须为下方显示带小数点的金额',
	转账金额必须为下方显示的金额且需要在倒计时内完成转账否则无法被系统确认:
		'转账金额必须为下方显示的金额，且需要在倒计时内完成转账，否则无法被系统确认！',
	状态: '状态',
	自定义: '自定义',
	自动扣款: '自动扣款',
	自动扣款中: '自动扣款中',
	总计: '总计',
	最低充值金额: '最低充值 {amount}',
	USDT地址已复制: 'USDT地址已复制',
}
